export const CaseTypeList = [
    {
        value: 0,
        label: '首勘',
    },{
        value: 1,
        label: '全流程',
    }
]
// 案件状态
export const PiccHumanStatusList = [
    {
        value: null,
        label: '全部',
    },{
        value: 0,
        label: '新案件',
    },{
        value: 10,
        label: '已指派人伤岗',
    },{
        value: 20,
        label: '已指派查勘中',
    },{
        value: 25,
        label: '指派查勘完成',
    },{
        value: 30,
        label: '查勘待审核',
    },{
        value: 40,
        label: '已完成',
    },{
        value: -1,
        label: '取消委托',
    },{
        value: -2,
        label: '未决案件',
    }
]
// 案件状态
export const PiccHumanStatusCaseList = [
    {
        value: null,
        label: '全部',
    },{
        value: 0,
        label: '新案件',
    },{
        value: 10,
        label: '待派工',
    },{
        value: 20,
        label: '作业中',
    },{
        value: 30,
        label: '待审核',
    },{
        value: 40,
        label: '案件完成',
    },{
        value: -1,
        label: '取消委托',
    },{
        value: -2,
        label: '未决',
    }
]
// 人伤任务状态
export const PiccHumanTaskStatusList = [
    {
        value: 10,
        label: '新任务',
    },{
        value: 20,
        label: '已指派查勘中',
    },{
        value: 25,
        label: '指派查勘完成',
    },{
        value: 30,
        label: '查勘待审核',
    },{
        value: 40,
        label: '已完成',
    },{
        value: -1,
        label: '取消委托',
    },{
        value: -2,
        label: '未决案件',
    }
]
// 案件任务状态
export const TaskStatusList = [
    {
        value: null,
        label: '全部',
    },{
        value: 0,
        label: '新任务',
    },{
        value: 10,
        label: '待派工',
    },{
        value: 20,
        label: '作业中',
    },{
        value: 30,
        label: '待审核',
    },{
        value: 40,
        label: '审核退回',
    },{
        value: 50,
        label: '任务完成',
    }
]

// 伤者任务状态
export const HumanStatusList = [
    {
        value: null,
        label: '全部',
    },{
        value: 0,
        label: '新任务',
    },{
        value: 10,
        label: '查勘中',
    },{
        value: 20,
        label: '查勘审核',
    },{
        value: 30,
        label: '查勘退回',
    },{
        value: 40,
        label: '人伤跟踪',
    },{
        value: 60,
        label: '方案制作中',
    },{
        value: 70,
        label: '方案审核',
    },{
        value: 72,
        label: '审核退回',
    },{
        value: 75,
        label: '协议签署中',
    },{
        value: 80,
        label: '任务完成',
    }
]
// 伤者调解状态
export const HumanTjStatusList = [
    {
        value: null,
        label: '全部',
    },{
        value: 0,
        label: '未调解',
    },{
        value: 10,
        label: '方案制作中',
    },{
        value: 20,
        label: '方案审核',
    },{
        value: 30,
        label: '调解退回',
    },{
        value: 40,
        label: '调解完成',
    }
]
// 财务状态
export const FinancialStatusList = [
    {
        value: null,
        label: '全部',
    },{
        value: 1,
        label: '已开票未回款',
    },{
        value: 2,
        label: '已开票部分回款',
    },{
        value: 3,
        label: '回款完成',
    },{
        value: 4,
        label: '已回款未开票',
    },{
        value: 5,
        label: '其他',
    }
]